export const SOLUTION_LIMIT = 10;

export const make14Dday = (date) =>
  moment(moment(date).format('YYYY-MM-DD')).add(14, 'days').diff(moment().format('YYYY-MM-DD'), 'days');
